module.exports = __webpack_public_path__ + "img/book.43bb3a82.svg";